module.exports = __webpack_public_path__ + "img/lamp_post.c446a7bb.jpg";